export interface ITicket {
  id: number;
  ticketId: string;
  ticketNumber: number;
  isCheckedIn: boolean;
  checkedInDate?: string | null;
  isFreeTicket?: boolean | null;
  fullName?: string;
  ticketOption?: string;
  discountGroupTitle?: string;
}

export interface ITicketHolder {
  activityLogId: number;
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
  phoneNumber: string;
  organizationName: string;
  totalTicketsPurchased: number;
  ticketsCheckedIn: number;
  tickets: ITicket[];
  purchaseDate: string;
  ticketOption: string;
  itemId?: number | null;
  itemDisplayId: string;
  isCollapsed?: boolean; // Collapse state for UI
}

export interface ITicketHolderFilter {
  searchTerm?: string | null;
  itemId?: number | null;
  checkInStatus?: number | null;
  campaignId: number;
}

export interface ICheckInRequest {
  ticketId: number;
  isCheckedIn: boolean;
}

/** Response from check-in by QR. status: CheckedIn | AlreadyCheckedIn. Invalid/not found returns 404. */
export interface ICheckInByQRResponse {
  status: 'CheckedIn' | 'AlreadyCheckedIn' | 'InvalidQRCode';
}
